import { render, staticRenderFns } from "./InterestSettings.vue?vue&type=template&id=24037157&"
import script from "./InterestSettings.vue?vue&type=script&lang=js&"
export * from "./InterestSettings.vue?vue&type=script&lang=js&"
import style0 from "./InterestSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports